import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { DaterangepickerComponent, DaterangepickerDirective } from 'ngx-daterangepicker-material';
import { ReminderLeadInput } from '../../../shared/models/lead/reminderLead.input';
import { FormsService } from '../../../shared/services/forms/forms.service';
import { ToastService } from '../../../shared/services/utils/toast.service';
import { LeadsComunicationService } from '../../leads/leads-comunication.service';
import { ModalsHandlerService } from '../modals.handler.service';

@Component({
  selector: 'ngx-reminder-modal',
  templateUrl: './reminder-modal.component.html',
  styleUrls: []
})
export class ReminderModalComponent implements AfterViewInit {

  @ViewChild('content', { static: false }) content: Element;
  @ViewChild(DaterangepickerDirective, { static: false }) pickerDirective: DaterangepickerDirective;
  picker: DaterangepickerComponent;
  dateModel = moment();
  today = moment().format('yyyy-MM-ddTHH:mm');
  otherDateModel: any;
  otherTimeModel: any;
  reminderLeadInput: ReminderLeadInput;
  defaultReminder: boolean;
  reminderForm: FormGroup;
  sending = false;
  leadId: string;
  canRemoveReminder: boolean;
  haveReminder: boolean;

  constructor(private readonly modalsHandler: ModalsHandlerService,
    private readonly modalService: NgbModal,
    private readonly toasterService: ToastService,
    private readonly leadComuService: LeadsComunicationService,
    private readonly formsService: FormsService) { }

  ngAfterViewInit(): void {

    this.modalsHandler.reminderModal.subscribe(data => {

      let reminderDate = null;
      if (data.reminderDate) {
        reminderDate = moment.unix(data.reminderDate / 1000);
        this.haveReminder = true;
        this.canRemoveReminder = reminderDate ? reminderDate.isAfter(moment()) : false;
        this.defaultReminder = false;
      } else {
        reminderDate = moment().add(1, 'hours');
        this.defaultReminder = true;
        this.haveReminder = false;
      }
      this.reminderForm = this.formsService.initFormReminder(reminderDate, this.defaultReminder);

      this.leadId = data.leadId;
      this.modalService
        .open(this.content, {
          size: 'lg',
          container: 'nb-layout',
          ariaLabelledBy: 'modal-basic-title',
          backdrop: 'static', keyboard: false
        });
    });
  }

  selectDatetoReminder(amount: any, unit: string): void {
    this.canRemoveReminder = false;
    // TODO review method deprecated
    // tslint:disable-next-line
    const newDate = moment().add(amount, unit);
    this.reminderForm.get('reminderDate').setValue(newDate.format('YYYY-MM-DDTHH:mm'));
  }

  reminderLead(isDeleteReminder?: boolean): void {
    if (!this.reminderForm.valid && !isDeleteReminder) {
      return;
    }

    const reminderLeadInput = this.formsService.bindReminderForm(this.leadId, this.reminderForm);
    this.formsService.sendReminderForm(reminderLeadInput)
      .then(() => {
        this.sending = true;
        this.modalService.dismissAll();
        this.leadComuService.launchReloadMyLead(this.leadId);
        this.toasterService
          .showToast(
            'success',
            'toaster.title.lead_reminder_success',
            'toaster.lead_reminder_success'
          );
        this.sending = false;
      })
      .catch(err => {
        this.toasterService
          .showToast(
            'error',
            'Error de envío',
            err.message
          );
        this.sending = false;
      });
  }

  removeReminder(): void {
    this.reminderForm.get('reminderDate').setValue('');
    this.reminderLead(true);
  }

}
